import local from "../classes/local";
import getEnvironment from "../functions/get.environment";
import getUrlParameters from "../functions/get.url.parameters";

export const withUtag = (loadView) => {

   let utagPromise;
   if (!utagPromise) {
      utagPromise = new Promise(async (resolve) => {
         for (let counter = 0; counter < 50; counter++) {
            if (window?.utag?.view) {
               resolve(window.utag);
               return;
            }
            await new Promise(res => setTimeout(res, 1000));
         }
      });
   }
    return utagPromise;
};

export const pageView = (pageName, stepNum, stepName) => {
   const language = local.getItem('language') === 'Spanish' ? 'es' : 'en';
   const location = window.location;
   const params = getUrlParameters();
   
   if (stepNum) {
      stepNum = stepNum.toString();
   } else {
      stepNum = null;
   }
   if (!stepName) {
      stepName = null;
   }

   const data = {
      // page
      language,
      page_url: location.href,
      page_path: location.pathname,
      page_name: pageName,
      page_title: document.title,
      site_section: 'accounts',
      site_tool: 'login',
      step_number: stepNum,
      step_name: stepName,
      site_environment: getEnvironment(),

      // user
      logged_in: 'false',
      requesting_site_tool: params.client_id || '',

      // event
      event_name: 'pageview',
      event_type: 'pageview'
   }
    
    // Use the resolved utag object from the Promise
   withUtag(true).then(utag => {  
      utag.view(data);
   })

};

const utagLink = data => {
   withUtag().then(utag => {
      utag.link(data);
   })
}

const defaultTealiumData = () => {
   const data = {
      // event
      event_name: '',
      event_type: 'ui interaction',
      error_type: null,
      error_code: null,
      error_message: null,
      text: null,
      target_location: null,
      heading: null,
      component: '',

      //UA and legacy requirements
      event_category: 'accounts',
      event_action: '',
      event_label: '',
      event_noninteraction: true
   }

   return data;
}

export const buttonClick = (text, target_location = '') => {
   const data = Object.assign(defaultTealiumData(), {
      event_name: 'button_click',
      text,
      component: 'button',
      event_action: 'button clicked',
      target_location,
      event_label: target_location || text,
      event_noninteraction: false
   });

   utagLink(data);
};

export const linkClick = (text, target_location = '') => {
   const data = Object.assign(defaultTealiumData(), {
      event_name: 'link_click',
      text,
      component: 'link',
      event_action: 'link clicked',
      target_location,
      event_label: target_location || text,
      event_noninteraction: false
   });

   utagLink(data);
};

export const helpDrawerImpression = (heading) => {
   const data = Object.assign(defaultTealiumData(), {
      event_name: 'help_drawer_impression',
      heading,
      component: 'help drawer',
      event_action: 'help drawer impression',
      event_label: heading
   });

   utagLink(data);
};

export const modalImpression = (heading) => {
   const data = Object.assign(defaultTealiumData(), {
      event_name: 'modal_impression',
      heading,
      component: 'modal',
      event_action: 'modal impression',
      event_label: heading
   });

   utagLink(data);
};

export const formStart = (formName) => {
   const data = Object.assign(defaultTealiumData(), {
      event_name: 'form_start',
      component: 'form',
      event_action: formName,
      event_label: 'start form',
      event_noninteraction: false
   });

   utagLink(data);
};

/** onClick handler for <a></a> to track analytics */
export const trackLinkClick = (e) => {
   if (!e.currentTarget) {
      return;
   }
   const el = e.currentTarget;
   linkClick(el.textContent.trim(), el.href);
};

const sharedConversionEventData = (component, conversionName, status = '') => {
   let event_name = conversionName;
   if (status) {
      event_name = [conversionName, status].join('_');
   }
   const data = Object.assign(defaultTealiumData(), {
      event_name,
      event_type: 'conversion',
      event_action: conversionName,
      component,     // login, create account, forgot password, etc. (friendlier name of conversion name) 
      event_noninteraction: true // false for attempts
   });

   return data;

};

export const conversionAttempt = (component, conversionName) => {
   const status = 'attempted';
   const data = Object.assign(sharedConversionEventData(component, conversionName, status), {
      event_label: status,
      event_noninteraction: false
   });

   utagLink(data);
};

export const conversionSuccess = (component, conversionName) => {
   const data = Object.assign(sharedConversionEventData(component, conversionName), {
      event_label: 'succeeded'
   });
   utagLink(data);
}

/** Multi step processes should not have "succeeded" or "failed" event labels - just "error" if there is an error */
export const conversionIntermediateFailure = (component, conversionName, errorType, errorMessage, errorCode = '') => {
   const status = 'error';
   const data = Object.assign(sharedConversionEventData(component, conversionName, status), {
      error_type: errorType,
      error_message: errorMessage,
      event_label: status
   });

   if (errorCode) {
      data.error_code = errorCode;
   }

   utagLink(data);
}

export const conversionFailure = (component, conversionName, errorType, errorMessage, errorCode = '') => {
   const status = 'failed';
   const data = Object.assign(sharedConversionEventData(component, conversionName, status), {
      error_type: errorType,
      error_message: errorMessage,
      event_label: status
   });

   if (errorCode) {
      data.error_code = errorCode;
   }

   utagLink(data);
}